import { useDateTimeFormat } from '@core/shared';
import { testWebinarDeleteOn } from '@core/types';
import { DateTime } from 'luxon';

/**
 * The moment a test webinar is deleted (planned start + 24 h), formatted for display. Safe to call
 * for every webinar — hooks run unconditionally — and for an empty or invalid date, which yields
 * an empty string instead of a RangeError from Date.toISOString().
 */
export function useTestWebinarDeleteOn(broadcastDateTime?: string | null): string {
    const parsed = broadcastDateTime ? new Date(broadcastDateTime) : null;
    const iso = parsed && !Number.isNaN(parsed.getTime()) ? testWebinarDeleteOn(broadcastDateTime!) : '';
    const { deleteOn } = useDateTimeFormat(iso, { deleteOn: DateTime.DATETIME_MED });
    return iso ? deleteOn : '';
}
